var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEditSmallGreen = function SvgEditSmallGreen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m13.349 8.899-2.246-2.246 1.623-1.624 2.245 2.245-1.622 1.625Zm-5.783 5.788-2.48.226.22-2.463 4.68-4.681 2.247 2.246-4.667 4.672Zm8.604-8.572-.001-.001-2.282-2.282c-.617-.616-1.678-.645-2.263-.057L4.127 11.27c-.272.271-.44.631-.475 1.012l-.316 3.475a.835.835 0 0 0 .906.905l3.475-.316c.382-.035.74-.202 1.012-.473l7.497-7.498c.607-.608.581-1.623-.056-2.261Z",
    fill: "#008545"
  })));
};
export default SvgEditSmallGreen;